import { ExamEventCard, type ExamEventCardProps } from '@exam-center/exam-event-schedule';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Link } from '@exam-center/router';
import { Button, Flex, Loading } from '@shared/components';
import { WithPermission } from '@shared/permissions';

import { EmptyUpcomingExamEventOverlay } from '../empty-upcoming-exam-event-overlay';

export interface UpcomingExamEventsProps {
  examCenterCode: string;
  loading?: boolean;
  examEvents?: (ExamEventCardProps & { id: string })[];
  onViewAllExamEvents?: () => void;
}

export default function UpcomingExamEvents(props: Readonly<UpcomingExamEventsProps>) {
  const { examCenterCode, examEvents, loading, onViewAllExamEvents } = props;

  if (loading) {
    return <Loading />;
  }

  if (!examEvents || examEvents.length === 0) {
    return <EmptyUpcomingExamEventOverlay />;
  }

  return (
    <>
      <Flex
        sx={(theme) => ({
          gap: theme.spacing(4),
          flexDirection: 'column',
          width: '100%',
          '& a': {
            textDecoration: 'none',
          },
        })}
      >
        {examEvents.map((examEvent) => (
          <Link
            to='/:examCenterCode/exam-events/:examEventId'
            params={{
              examCenterCode,
              examEventId: examEvent.id,
            }}
            key={examEvent.id}
          >
            <ExamEventCard {...examEvent} sx={{ textDecoration: 'none' }} />
          </Link>
        ))}
      </Flex>
      <WithPermission requiredPermission={APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW}>
        <Button
          color='secondary'
          onClick={onViewAllExamEvents}
          sx={(theme) => ({ width: '200px', background: theme.palette.grey[100] })}
        >
          ดูรอบสอบทั้งหมด
        </Button>
      </WithPermission>
    </>
  );
}
